module.exports = __webpack_public_path__ + "media/images/chats/kabul-prison-is-open-and-the-prisoners-escape.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/chats/kabul-prison-is-open-and-the-prisoners-escape.jpg
// module id = 73
// module chunks = 0